/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NoteVo
 */
export interface NoteVo {
    /**
     * ID
     * @type {number}
     * @memberof NoteVo
     */
    id?: number;
    /**
     * 发送者ID
     * @type {number}
     * @memberof NoteVo
     */
    senderId?: number;
    /**
     * 发送者名称
     * @type {string}
     * @memberof NoteVo
     */
    senderName?: string;
    /**
     * 接收者ID
     * @type {number}
     * @memberof NoteVo
     */
    receiverId?: number;
    /**
     * 接收者名称
     * @type {string}
     * @memberof NoteVo
     */
    receiverName?: string;
    /**
     * 接收者会员编号
     * @type {string}
     * @memberof NoteVo
     */
    receiverCode?: string;
    /**
     * 标题
     * @type {string}
     * @memberof NoteVo
     */
    title?: string;
    /**
     * 内容
     * @type {string}
     * @memberof NoteVo
     */
    content?: string;
    /**
     * 订单ID
     * @type {number}
     * @memberof NoteVo
     */
    orderId?: number;
    /**
     * 订单号
     * @type {string}
     * @memberof NoteVo
     */
    orderCode?: string;
    /**
     * 状态：0未读/1已读
     * @type {string}
     * @memberof NoteVo
     */
    noteStatus?: string;
    /**
     * 读取时间
     * @type {string}
     * @memberof NoteVo
     */
    readTime?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof NoteVo
     */
    createTime?: string;
}

/**
 * Check if a given object implements the NoteVo interface.
 */
export function instanceOfNoteVo(value: object): value is NoteVo {
    return true;
}

export function NoteVoFromJSON(json: any): NoteVo {
    return NoteVoFromJSONTyped(json, false);
}

export function NoteVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoteVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'senderId': json['senderId'] == null ? undefined : json['senderId'],
        'senderName': json['senderName'] == null ? undefined : json['senderName'],
        'receiverId': json['receiverId'] == null ? undefined : json['receiverId'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'receiverCode': json['receiverCode'] == null ? undefined : json['receiverCode'],
        'title': json['title'] == null ? undefined : json['title'],
        'content': json['content'] == null ? undefined : json['content'],
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'noteStatus': json['noteStatus'] == null ? undefined : json['noteStatus'],
        'readTime': json['readTime'] == null ? undefined : json['readTime'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
    };
}

export function NoteVoToJSON(json: any): NoteVo {
    return NoteVoToJSONTyped(json, false);
}

export function NoteVoToJSONTyped(value?: NoteVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'senderId': value['senderId'],
        'senderName': value['senderName'],
        'receiverId': value['receiverId'],
        'receiverName': value['receiverName'],
        'receiverCode': value['receiverCode'],
        'title': value['title'],
        'content': value['content'],
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'noteStatus': value['noteStatus'],
        'readTime': value['readTime'],
        'createTime': value['createTime'],
    };
}

